import { ISubscriptionService } from "./ISubscriptionService";
import { SupabaseSubscriptionService } from "./SupabaseSubscriptionService";
import { ApiSubscriptionService } from "./ApiSubscriptionService";

export * from "./ISubscriptionService";

const APP_TYPE = import.meta.env.VITE_APP_TYPE || "supabase";

function createSubscriptionService(): ISubscriptionService {
  switch (APP_TYPE) {
    case "api":
      return new ApiSubscriptionService();
    case "supabase":
    default:
      return new SupabaseSubscriptionService();
  }
}

export const SubscriptionService = createSubscriptionService();
